import { defineComponent as _defineComponent } from 'vue'
import { computed, watch } from 'vue';

import {
  NavBar,
  HeadingDisplay,
  ContentDisplay,
  Heading,
  Row,
  BaseIcon,
  ButtonContainer,
  ButtonPrimary,
  BaseText
} from '@warrenbrasil/nebraska-web';
import { SideSheet } from '@/modules/common/components/SideSheet';
import { BackButton } from '@/modules/common/components/buttons';

import { removeBodyScroll } from '@/modules/common/helpers/browser';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import InstrumentAvatar from '@/modules/trade/components/InstrumentAvatar/InstrumentAvatar.vue';

interface IData {
  requestTermsSignature: {
    productId: string;
    productName: string;
    productDescription?: string;
    symbol?: string;
    documents: {
      label: string;
      url: string;
    }[];
  }[];
}

interface EmitEvents {
  (event: 'close'): void;
  (event: 'confirm'): void;
}
interface Props {
  isOpen: boolean;
  data: IData;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'TermsSignature',
  props: {
    isOpen: { type: Boolean },
    data: null
  },
  emits: ["close", "confirm"],
  setup(__props: any) {

const props = __props as {
  isOpen: boolean;
  data: IData;
};





const productName = computed(
  () => props.data.requestTermsSignature[0].productName
);

const productDescription = computed(
  () => props.data.requestTermsSignature[0].productDescription
);

const productSymbol = computed(
  () => props.data.requestTermsSignature[0].symbol
);

const documents = computed(() => props.data.requestTermsSignature[0].documents);

function openDocument(url: string) {
  window.open(url, '_blank');
}

watch(
  () => props.isOpen,
  _isOpen => {
    removeBodyScroll();
  }
);

return { __sfc: true,props, productName, productDescription, productSymbol, documents, openDocument, NavBar, HeadingDisplay, ContentDisplay, Heading, Row, BaseIcon, ButtonContainer, ButtonPrimary, BaseText, SideSheet, BackButton, NebraskaColors, InstrumentAvatar }
}

})